module.exports = __webpack_public_path__ + "static/cube10-67b0211f9a3a9b294676e2989227c1e7.svg";